import {Button, Input} from "@material-ui/core";
import React, {useState} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

const styles = () => ({
    title: {
        marginRight: 10,
    },
    optionButtonGeneral: {
        borderRadius: 0,
        borderWidth: 1,
    },
    optionButtonNotSelected: {
        backgroundColor: 'white',
        color: 'black',
    },
    optionButtonSelected: {
        backgroundColor: 'orange',
        color: 'black',
        '&:hover': {
            backgroundColor: 'orange',
        }
    }
})

const KeywordSearchBar = ({
    searchFieldOptions = [],
    searchField = '',
    onClickSearchButton = () => null,
    classes,
}) => {
    const [ searchKeyword, setSearchKeyword ] = useState('')
    return (
        <div className="flex justify-start items-center h-full">
            <Input
                value={searchKeyword}
                onChange={event => setSearchKeyword(event.target.value)}
                placeholder="請輸入關鍵字"
                className={classes.title}
            />
            {searchFieldOptions.map(option => (
                <Button
                    key={option.searchField}
                    onClick={() => {
                        onClickSearchButton(option.searchField, searchKeyword)
                    }}
                    variant="outlined"
                    className={[
                        classes.optionButtonGeneral,
                        searchField === option.searchField
                            ? classes.optionButtonSelected
                            : classes.optionButtonNotSelected
                    ]}
                >
                    {option.displayText}
                </Button>))}
            <Button
                key={'clear'}
                onClick={() => {
                    setSearchKeyword('')
                    onClickSearchButton('', '')
                }}
                variant="contained"
                color="default"
                className="m-8"
            >
                清除篩選
            </Button>
        </div>
    )
}

KeywordSearchBar.propTypes = {
    title: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    selectedOptions: PropTypes.string,
    onSelectedOption: PropTypes.func,
}

export default withStyles(styles)(KeywordSearchBar)



// WEBPACK FOOTER //
// ./src/components/KeywordSearchBar.js